import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { ensureExists } from '~/utils'

import { type StrategyMemo } from './useMainQuery'
import { useMainQueryKey } from './useMainQueryKey'

export const useMainQueryStrategyMemo = () => {
  const { t } = useTranslation()
  const queryKey = useMainQueryKey()
  const { data } = useQuery<StrategyMemo>({ enabled: false, queryKey })

  return ensureExists(data, t('assertion_failed'))
}
